import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import { createNumberTracker, deleteNumberTracker, listGeneralSetting, listUsedVoucherSerialNumbers, listVoucherSerialNumbers ,updateNumberTracker} from '../../graphql';

export const VoucherSettingsApi = createApi({
    reducerPath: 'voucherSettigsApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        listGeneralSetting:builder.query({
            query: (variables) => ({ body: listGeneralSetting, variables }),
            keepUnusedDataFor: Infinity,
            refetchOnMountOrArgChange: true,
            providesTags: (result, error, { entrytypecd }) => [
                { type: "listGeneralSettings", id: entrytypecd },
                { type: "listGeneralSettings", id: "ALL" },
            ],
        }),
        listVoucherSerialNumbers: builder.query({
            query: (variables) => ({ body: listVoucherSerialNumbers, variables }),
            keepUnusedDataFor: Infinity,
            refetchOnMountOrArgChange: true,
            providesTags: (result, error, { entrytypecd }) => [
                { type: "listVoucherSettings", id: entrytypecd },
                { type: "VoucherSerialNumbers", id: "ALL" },
            ],
        }),
        listUsedVoucherSerialNumbers: builder.query({
            query: (variables) => ({ body: listUsedVoucherSerialNumbers, variables }),
            keepUnusedDataFor: Infinity,
            refetchOnMountOrArgChange: true,
            providesTags: ['listUsedVoucherSettings'],
        }),
        createNumberTracker: builder.mutation({
            query: (variables) => ({ body: createNumberTracker, variables }),
            invalidatesTags: (result, error, { entrytypecd }) => [
                { type: "listVoucherSettings", id: entrytypecd },
            ],
        }),
        updateNumberTracker: builder.mutation({
            query: (variables) => ({ body: updateNumberTracker, variables }),
            invalidatesTags: (result, error, { entrytypecd }) => [
                { type: "listVoucherSettings", id: entrytypecd },
            ],
        }),
        deleteNumberTracker: builder.mutation({
            query: (variables) => ({ body: deleteNumberTracker, variables }),
            invalidatesTags: (result, error, { entrytypecd }) => [
                { type: "listVoucherSettings", id: entrytypecd },
            ],
        }),
    }),
});

export const {useListGeneralSettingQuery, useListVoucherSerialNumbersQuery, useListUsedVoucherSerialNumbersQuery, useCreateNumberTrackerMutation,useUpdateNumberTrackerMutation , useDeleteNumberTrackerMutation} = VoucherSettingsApi;
